import { sortBy, startCase } from 'lodash';
import qs from 'qs';
import React from 'react';
import { useLocation, useParams } from 'react-router-dom';

import Logo from 'App/components/Header/Logo';
import SessionTimer from 'App/components/Header/icons/SessionTimer';
import FlexCenter from 'App/components/styles/FlexCenter';
import Main from 'App/components/styles/Main/Main';
import PageWrapper from 'App/components/styles/PageWrapper/PageWrapper';
import TherigyLoadingSpinner from 'App/components/TherigyLoadingSpinner';
import CMSService from 'App/services/CMSService';
import convertToastUISyntax from 'App/utils/convertToastUISyntax/convertToastUISyntax';
import hasLength from 'App/utils/hasLength';
import useFetchContentMonograph from './hooks/useFetchContentMonograph';
import Markdown from 'markdown-to-jsx';

const ContentMonographDisplay = () => {
    const { label } = useParams();
    const { search } = useLocation();
    const parsedSearchQueries = qs.parse(search, { ignoreQueryPrefix: true });
    const { labels } = parsedSearchQueries;
    const { data, isLoading } = useFetchContentMonograph(label, { labels });

    if (isLoading) {
        return (
            <Main>
                <PageWrapper>
                    <FlexCenter>
                        <TherigyLoadingSpinner />
                    </FlexCenter>
                </PageWrapper>
            </Main>
        );
    }

    const monographs = Object.values(data);

    return (
        <div className="content-monograph-display">
            {hasLength(monographs) ? (
                monographs.map((cg) => (
                    <React.Fragment key={cg.id}>
                        <div className="content-monograph-header">
                            <div className="content-monograph-header-left">
                                <Logo />
                                <div
                                    id={`content-modal-group-name-${cg.label}`}
                                    className="content-monograph-group-name"
                                >
                                    {startCase(cg.name)}
                                </div>
                            </div>
                            <SessionTimer />
                        </div>
                        <div className="content-monograph-content markdown-contents">
                            {sortBy(cg.contentVersions, (cv) => CMSService.labelOrder[cg.type].indexOf(cv.label)).map(
                                (cv) => {
                                    if (!cv.content) {
                                        return null;
                                    }
                                    return (
                                        <div key={cv.id} id={`content-modal-content-${cg.label}-${cv.label}`}>
                                            <Markdown>{convertToastUISyntax(cv.content)}</Markdown>
                                        </div>
                                    );
                                }
                            )}
                        </div>
                    </React.Fragment>
                ))
            ) : (
                <>
                    <div className="content-monograph-header">
                        <Logo />
                        <SessionTimer />
                    </div>
                    <Main>
                        <PageWrapper>
                            <p>No monograph data found.</p>
                        </PageWrapper>
                    </Main>
                </>
            )}
        </div>
    );
};

export default ContentMonographDisplay;
